export function getCategoryList() {
  const list = [{
    icon: 'standard',
    title: '标准服务',
    category: 'A2',
    url: 'service'
  }, {
    icon: 'detection',
    title: '检验检测',
    category: 'A1',
    url: 'detection'
  }, {
    icon: 'metering',
    title: '计量服务',
    category: 'A4',
    url: 'metering'
  }, {
    icon: 'special',
    title: '特种设备',
    category: 'A6',
    url: 'equipment'
  }, {
    icon: 'authentication',
    title: '认证认可',
    category: 'A3',
    url: 'authentication'
  }, {
    icon: 'knowledge',
    title: '知识产权',
    category: 'A5',
    url: 'property'
  }, {
    icon: 'brand',
    title: '品牌建设',
    category: 'A7',
    url: 'brand'
  }, {
    icon: 'quality',
    title: '质量提升',
    category: 'A8',
    url: 'quality'
  }, {
    icon: 'build',
    title: '体系建设',
    category: 'A10',
    url: 'construction'
  }, {
    icon: 'device',
    title: '设备共享',
    category: 'A100',
    url: 'facility'
  }, {
    icon: 'diagnose',
    title: '质量问诊',
    category: 'A99',
    url: 'inquiry'
  }]
  return list
}
